/* ==========================================================================
   Aronia ORIGINAL — Cart drawer behaviour (Krown "Local")
   Vanilla JS, no deps, loaded with `defer`. Namespace: window.AoCart
   Responsibilities:
     - open/close the drawer + scrim, lock <html> scroll (only inner scrolls)
     - talk to Shopify Cart AJAX API (/cart/change.js, /cart/add.js, /cart.js)
     - re-render line items + totals from the returned cart JSON
     - compute the free-shipping progress bar from a threshold
     - accordions (discount / note), cross-sell quick-add
   Threshold source (in priority order):
     1) data-free-shipping-threshold on .aoc (injected by the section from a
        theme setting, in the shop's MINOR units — cents)
     2) window.AO_FREE_SHIPPING_THRESHOLD (cents)
     3) fallback 3500 (=35,00 €)
   NOTE ON AUTOMATIC VALUE: Shopify does NOT expose shipping-zone rate
   thresholds to the storefront via Liquid/JS. So the "automatic" path is:
   create the free-shipping rate in Settings → Shipping, AND mirror the amount
   in the theme setting (schema id: free_shipping_threshold). See README §4.
   ========================================================================== */
(function () {
  var SEL = '[data-ao-cart]';

  function money(cents, cur) {
    // Uses the shop's money format if provided globally; else de-DE €.
    try {
      if (window.Shopify && Shopify.formatMoney && window.AO_MONEY_FORMAT)
        return Shopify.formatMoney(cents, window.AO_MONEY_FORMAT);
    } catch (e) {}
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: cur || 'EUR' });
  }

  function AoCart(root) {
    this.root = root;
    this.scrim = document.querySelector('[data-ao-cart-scrim]');
    this.threshold = parseInt(root.getAttribute('data-free-shipping-threshold'), 10);
    if (isNaN(this.threshold)) this.threshold = window.AO_FREE_SHIPPING_THRESHOLD || 3500;
    // Beschriftung der Schwelle aus demselben Theme-Setting wie die Rechnung (ao-cart.liquid).
    // Vorher stand „35 €“ als Konstante im Text, waehrend der Balken dem Regler folgte — ein
    // Verstellen von „Gratisversand ab (€)“ haette Text und Fortschritt auseinanderlaufen lassen.
    this.shipLabel = root.getAttribute('data-free-shipping-label') || '35\u00A0€';
    this.currency = root.getAttribute('data-currency') || 'EUR';
    this.bind();
  }

  AoCart.prototype.bind = function () {
    var self = this;
    // Open triggers: any element with [data-ao-cart-open] (header cart button)
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-ao-cart-open]');
      if (opener) { e.preventDefault(); self.open(); }
      if (e.target.closest('[data-ao-cart-close]')) { e.preventDefault(); self.close(); }
    });
    if (this.scrim) this.scrim.addEventListener('click', function () { self.close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });

    // Delegated controls inside the drawer
    this.root.addEventListener('click', function (e) {
      var inc = e.target.closest('[data-ao-inc]');
      var dec = e.target.closest('[data-ao-dec]');
      var rm  = e.target.closest('[data-ao-remove]');
      var add = e.target.closest('[data-ao-add]');
      var acc = e.target.closest('[data-ao-acc]');
      if (inc) self.changeLine(inc.getAttribute('data-key'), +1);
      if (dec) self.changeLine(dec.getAttribute('data-key'), -1);
      if (rm)  self.changeLine(rm.getAttribute('data-key'), 0, true);
      if (add) self.addItem(add.getAttribute('data-variant'));
      if (acc) self.toggleAcc(acc);
    });
  };

  AoCart.prototype.open = function () {
    this.root.classList.add('is-open');
    if (this.scrim) this.scrim.classList.add('is-open');
    document.documentElement.classList.add('aoc-lock');
    this.refresh();
  };
  AoCart.prototype.close = function () {
    this.root.classList.remove('is-open');
    if (this.scrim) this.scrim.classList.remove('is-open');
    document.documentElement.classList.remove('aoc-lock');
  };

  AoCart.prototype.toggleAcc = function (head) {
    var body = head.nextElementSibling;
    var open = body.hasAttribute('hidden');
    if (open) body.removeAttribute('hidden'); else body.setAttribute('hidden', '');
    var icon = head.querySelector('i'); if (icon) icon.textContent = open ? '−' : '+';
  };

  // ---- Cart AJAX ---------------------------------------------------------
  AoCart.prototype.refresh = function () {
    var self = this;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { self.render(cart); });
  };
  AoCart.prototype.changeLine = function (key, delta, remove) {
    var self = this;
    // Find current qty from DOM, compute next
    var row = this.root.querySelector('[data-line="' + key + '"]');
    var cur = row ? parseInt(row.getAttribute('data-qty'), 10) : 1;
    var next = remove ? 0 : Math.max(0, cur + delta);
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: next })
    }).then(function (r) { return r.json(); }).then(function (cart) { self.render(cart); self.pingCount(cart); });
  };
  AoCart.prototype.addItem = function (variantId) {
    var self = this;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    }).then(function () { self.refresh(); });
  };
  AoCart.prototype.pingCount = function (cart) {
    // Update the header cart count if present
    document.querySelectorAll('[data-ao-cart-count], .ao-cart__count').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  };

  /* Abo-Kennzeichnung (05.08.2026). Dieser Drawer baut seine Zeilen selbst aus /cart.js,
     nicht aus cart-form.liquid — das dortige Badge greift hier also NICHT. Ohne diese
     Zeile sieht der Kunde im Side-Cart nur einen guenstigeren Preis und erfaehrt nicht,
     dass er ein Abo bestellt.
     Nur options[0].value statt selling_plan.name: Der volle Name („Alle 4 Wochen liefern,
     12.5 % Rabatt") sprengt die schmale Zeile, der Rabatt steckt ohnehin im Preis. */
  function aboBadge(it) {
    var a = it.selling_plan_allocation;
    if (!a || !a.selling_plan) return '';
    var opt = a.selling_plan.options && a.selling_plan.options[0];
    var takt = (opt && (opt.value || opt)) || a.selling_plan.name || '';
    var aboLabel = (window.AO_I18N && window.AO_I18N['ao.cart.subscription_label']) || 'Abo · ';
    return '<span class="ao-cart-abo">' +
      '<svg class="ao-cart-abo__icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
        '<path d="M2.5 8a5.5 5.5 0 0 1 9.2-4.1M13.5 8a5.5 5.5 0 0 1-9.2 4.1" fill="none" ' +
          'stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '<path d="M11.4 1.4v2.6H8.8M4.6 14.6V12h2.6" fill="none" stroke="currentColor" ' +
          'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg><span>' + aboLabel + esc(takt) + '</span></span>';
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---- Render ------------------------------------------------------------
  AoCart.prototype.render = function (cart) {
    var self = this;
    this.pingCount(cart);
    // Title count
    var cnt = this.root.querySelector('[data-ao-count]');
    var itemsSuffix = (window.AO_I18N && window.AO_I18N['ao.cart.items_suffix']) || 'Artikel';
    if (cnt) cnt.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? itemsSuffix : itemsSuffix);

    // Free-shipping bar (cart.total_price is in cents, excl. shipping).
    // Gutschein zaehlt nicht zur Grenze (08.10.2026, eigenes Versandprofil „Versand per Brief"
    // 0 EUR; Shopify prueft die 35-EUR-Grenze nur ueber die Waren). Reiner Gutschein-Warenkorb:
    // Balken ausblenden — er wird nie mit Versand berechnet. Gleiche Regel wie in ao-cart.liquid.
    var gutschein = 0, waren = 0;
    (cart.items || []).forEach(function (it) {
      if (it.product_type === 'Gutschein') gutschein += it.final_line_price; else waren += 1;
    });
    var total = cart.total_price - gutschein;
    var nurGutschein = cart.item_count > 0 && waren === 0;
    var reached = total >= this.threshold && total > 0;
    var remaining = Math.max(0, this.threshold - total);
    var pct = this.threshold > 0 ? Math.min(100, (total / this.threshold) * 100) : 0;
    var ship = this.root.querySelector('.aoc__ship');
    if (ship) ship.style.display = nurGutschein ? 'none' : '';
    if (ship && !nurGutschein) {
      ship.classList.toggle('is-reached', reached);
      ship.querySelector('[data-ao-ship-fill]').style.width = pct + '%';
      // Zwei Gruende, warum hier weder eine absolute Zusage noch eine Angabe ohne Laender steht:
      //
      // 1. Shopify prueft TOTAL_PRICE >= Schwelle gegen die Zwischensumme NACH Rabatt, und keiner
      //    der aktiven Codes hat einen Mindestbestellwert (HANDBUCH §7novemtricies, Fehler 2).
      //    Wer bei 36 EUR im Checkout einen 5-EUR-Code einloest, zahlt Versand — „Ihr Versand ist
      //    kostenlos!" waere dann nachweislich falsch gewesen. Deshalb nennt der Text die Bedingung.
      // 2. Die Laenderangabe ist NOTWENDIG, nicht bloss bestaetigend. Das Gate in ao-cart.liquid
      //    prueft `localization.country` — das ist das Markt- und Preisland des Besuchers, NICHT
      //    die Lieferadresse. Die entsteht erst im Checkout. Ein Kunde in Deutschland, der nach
      //    Italien liefern laesst, passiert das Gate und zahlt an der Kasse 9,90 EUR (Zone „DHL
      //    Zone 1 (EU Laender)", frei erst ab 200 EUR). Ohne „(DE, AT)" waere die Aussage fuer ihn
      //    objektiv unrichtig, und eine objektiv unrichtige Blickfangangabe ist nach der
      //    BGH-Rechtsprechung keiner Aufklaerung mehr zugaenglich (§ 5 UWG). Dasselbe gilt fuer
      //    Besucher aus Laendern ohne eigenen Markt (CH, GB, US …), die Shopify dem Primaermarkt
      //    Deutschland zuordnet. Die Angabe darf in KEINEM der beiden Zustaende entfallen.
      var reachedTpl = (window.AO_I18N && window.AO_I18N['ao.cart.ship_reached_html']) ||
        'Geschafft — versandkostenfrei ab {{amount}} (DE,\u00A0AT)';
      var remainingTpl = (window.AO_I18N && window.AO_I18N['ao.cart.ship_remaining_html']) ||
        'Nur noch <span class="aoc__ship-amount">{{amount}}</span> bis zum GRATIS-Versand (DE,\u00A0AT)';
      ship.querySelector('[data-ao-ship-text]').innerHTML = reached
        ? reachedTpl.replace('{{amount}}', this.shipLabel)
        : remainingTpl.replace('{{amount}}', money(remaining, this.currency));
      ship.querySelector('[data-ao-ship-icon-leaf]').style.display  = reached ? 'none' : '';
      ship.querySelector('[data-ao-ship-icon-check]').style.display = reached ? '' : 'none';
    }

    // Subtotal
    var sub = this.root.querySelector('[data-ao-subtotal]');
    if (sub) sub.textContent = money(cart.total_price, this.currency);

    // Line items
    var list = this.root.querySelector('[data-ao-items]');
    var empty = this.root.querySelector('.aoc__empty');
    if (!list) return;
    // Zustandsklasse fuer die Cross-Sell-Ueberschrift (05.08.2026, Audit M-06):
    // "Passt gut dazu" ergibt ohne Bezugsartikel keinen Sinn.
    this.root.classList.toggle('aoc--empty', cart.item_count === 0);
    if (cart.item_count === 0) {
      list.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';
    list.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      var unit = it.unit_price_measurement
        ? money(it.unit_price, self.currency) + '/' + (it.unit_price_measurement.reference_value || '') + it.unit_price_measurement.reference_unit
        : '';
      var decLabel = (window.AO_I18N && window.AO_I18N['ao.cart.stepper_decrease']) || 'Weniger';
      var incLabel = (window.AO_I18N && window.AO_I18N['ao.cart.stepper_increase']) || 'Mehr';
      var removeLabel = (window.AO_I18N && window.AO_I18N['ao.cart.remove']) || 'Entfernen';
      return '' +
      '<div class="aoc__item" data-line="' + it.key + '" data-qty="' + it.quantity + '">' +
        '<div class="aoc__thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div>' +
          '<div class="aoc__item-top">' +
            '<div class="aoc__item-name">' + it.product_title + '</div>' +
            '<div class="aoc__item-price">' + money(it.final_line_price, self.currency) + '</div>' +
          '</div>' +
          (variant ? '<div class="aoc__item-variant">' + variant + '</div>' : '') +
          (unit ? '<div class="aoc__item-unit">' + unit + '</div>' : '') +
          aboBadge(it) +
          '<div class="aoc__item-foot">' +
            '<div class="aoc__stepper">' +
              '<button type="button" data-ao-dec data-key="' + it.key + '" aria-label="' + decLabel + '">−</button>' +
              '<span class="aoc__qty">' + it.quantity + '</span>' +
              '<button type="button" data-ao-inc data-key="' + it.key + '" aria-label="' + incLabel + '">+</button>' +
            '</div>' +
            '<button type="button" class="aoc__remove" data-ao-remove data-key="' + it.key + '">' + removeLabel + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
  };

  function boot() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (!el.__aoCart) el.__aoCart = new AoCart(el);
    });
    shimLegacyDrawer();
  }

  /* ---- AO-Integration Krown "Local" (2026-07-23, README §1.3 „Minimal") ----
     Krowns JS öffnet den alten Drawer #site-cart-sidebar nach Add-to-Cart/
     Quick-Buy HART via .show() (component-cart.js:187, component-quick-buy.js:13,
     section-main-product.js:100 — teils ohne ?.). Element daher im DOM lassen
     (sonst JS-Fehler), aber sein show() auf DIESEN Drawer umleiten: nach jedem
     Add öffnet der neue Side-Cart. Der alte bleibt unsichtbar (inline
     display:none, das nur sein originales show() entfernt hätte). */
  function shimLegacyDrawer() {
    var old = document.getElementById('site-cart-sidebar');
    var mine = document.querySelector(SEL);
    if (!old || !mine || old.__aoShimmed) return;
    old.__aoShimmed = true;
    old.show = function () { if (mine.__aoCart) mine.__aoCart.open(); };
  }

  /* ---- Header-Zaehler nach Add-to-Cart aktualisieren (05.08.2026) ----------
     Der Zaehler `.ao-cart__count` wurde nur ueber render() gepflegt, und render() lief
     ausschliesslich beim OEFFNEN des Drawers (open() -> refresh() -> render()). Legt der
     Kunde etwas in den Warenkorb, ohne dass der Drawer aufgeht, blieb im Header die alte
     Zahl stehen — bis irgendeine andere Aktion den Drawer oeffnete oder die Seite neu lud.
     Reproduziert: Server meldete 1 Artikel, der Header zeigte weiter 0.

     Krown feuert nach jedem erfolgreichen Add `krown:cart:add` auf `document`
     (component-product-form.js:806) und nach Mengenaenderungen `krown:cart:update`
     (component-cart.js:108). Beide Ereignisse ziehen jetzt einen refresh() nach sich.
     Das aktualisiert Zaehler UND Drawer-Inhalt, ohne das Oeffnungsverhalten zu aendern. */
  function aktualisiereAlle() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.__aoCart) el.__aoCart.refresh();
    });
  }
  document.addEventListener('krown:cart:add', aktualisiereAlle);
  document.addEventListener('krown:cart:update', aktualisiereAlle);

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);

  window.AoCart = { boot: boot };
})();
